(function(exports, $) {
    $(document).ready(function(){

        $('.lazy').unveil();

        initAvisoLegalFormularios();

        var $hiddenPMin = $('#inmotek_busqueda_pmin'),
            $hiddenPMax = $('#inmotek_busqueda_pmax'),
            $hiddenMMin = $('#inmotek_busqueda_mmin'),
            $hiddenMMax = $('#inmotek_busqueda_mmax'),
            $rangePrecio = $('input.range-slider.precio'),
            $rangeMetros = $('input.range-slider.superficie'),
            $sliderInmuebles = $('.slider-inmuebles'),
            $sliderBusqueda = $('.slider-busqueda'),
            $selectTipos = $('#inmotek_busqueda_tipo'),
            $selectSubtipos = $('#inmotek_busqueda_stipo'),
            $selectLocalidad = $('#inmotek_busqueda_loc'),
            $selectZonas = $('#inmotek_busqueda_zona'),
            $idiomas = $('header.main .traducir li');

        function initSliderInmuebles() {
            $sliderInmuebles.each(function() {
                var $this = $(this),
                    $owl = $this.find('.owl-carousel');

                $owl.owlCarousel({
                    loop: true,
                    autoplay: true,
                    lazyLoad: true,
                    autoWidth: true,
                    center: true,
                    nav: false,
                    margin: 20,
                    autoplayHoverPause: true
                });

                $this.find('.arrow').click(function() {
                    $owl.trigger($(this).attr('data-dir') + '.owl.carousel');
                });

            });
        }

        function initSliderBusqueda() {
            $sliderBusqueda.each(function() {
                var $this = $(this),
                    $owl = $this.find('.owl-carousel');

                $owl.owlCarousel({
                    loop: true,
                    autoplay: true,
                    lazyLoad: true,
                    items: 1,
                    center: true,
                    nav: false,
                    dots: false,
                    animateOut: 'fadeOut',
                    mouseDrag: false,
                    touchDrag: false,
                    rewind: false,
                    autoplayTimeout: 10000
                });

                $owl
                    .find('.owl-stage-outer, .owl-stage, .owl-item, div.owl-lazy')
                    .height($owl.parent().outerHeight());

            });
        }

        function rangePrecioOnChange(data) {
            $hiddenPMin.val(data.from_value);
            $hiddenPMax.val(data.to_value);
        }

        function rangeMetrosOnChange(data) {
            $hiddenMMin.val(data.from_value);
            $hiddenMMax.val(data.to_value);
        }

        function initRadioFormWidget() {
            var $todos = $('.radio-widget');

            $todos.each(function() {
                var $todosInputs = $(this).find('input'),
                    $todosRows = $(this).children('div');

                $todosRows.each(function() {
                    var $this = $(this),
                        $widget = $this.find('span'),
                        $input = $this.find('input');

                    if($input.is(':checked')) {
                        $this.addClass('checked');
                    }

                    $widget.click(function() {
                        var nuevoValor = !$input.is(':checked');
                        $todosInputs.attr('checked', false);
                        $todosRows.removeClass('checked');

                        $input.attr('checked', nuevoValor);

                        if(nuevoValor === true) {
                            $this.addClass('checked');
                        }

                        $input.trigger('change');
                    });

                    $input.trigger('change');
                });
            });
        }

        function initCheckboxFormWidget() {
            var $todos = $('.checkbox-widget');

            $todos.each(function() {
                var $todosInputs = $(this).find('input'),
                    $todosRows = $(this).children('div');

                $todosRows.each(function() {
                    var $this = $(this),
                        $widget = $this.find('span'),
                        $input = $this.find('input');

                    if($input.is(':checked')) {
                        $this.addClass('checked');
                    }

                    $widget.click(function() {
                        var nuevoValor = !$input.is(':checked');

                        $input.attr('checked', nuevoValor);

                        if(nuevoValor === true) {
                            $this.addClass('checked');
                        }else {
                            $this.removeClass('checked');
                        }

                        $input.trigger('change');
                    });

                    $input.trigger('change');
                });
            });
        }

        function initFormBusqueda() {

            var $wrapper = $('.form-busqueda-wrapper '),
                $form = $wrapper.find('form');

            if($(window).width() > 768) {
                var offsetTop = $form.outerHeight() / 1.4;
                $form.css({'top': offsetTop + 'px'});
                $wrapper.css({'margin-bottom': offsetTop + 'px'});
            }

            initCheckboxFormWidget();
            initRadioFormWidget();

            var optsPrecio = {
                type: 'double',
                prettify_separator: '.',
                prettify: function(value) {
                    return value.toLocaleString() + ' €';
                },
                grid: false,
                values: [0, 100, 200, 300, 400, 500, 1000, 2000, 5000, 10000],
                grid_num: 4,
                onChange: rangePrecioOnChange,
                onUpdate: rangePrecioOnChange
            };

            $rangePrecio.ionRangeSlider(optsPrecio);

            $rangeMetros.ionRangeSlider({
                type: 'double',
                prettify_separator: '.',
                prettify: function(value) {
                    return value.toLocaleString() + ' m2';
                },
                grid: false,
                values: [0, 50, 100, 200, 300, 400, 500, 1000, 2000, 10000],
                grid_num: 4,
                onChange: rangeMetrosOnChange,
                onUpdate: rangeMetrosOnChange
            });

            var ionPrecio = $rangePrecio.data("ionRangeSlider"),
                ionMetros = $rangeMetros.data("ionRangeSlider");

            var preciosMap = {
                Alquiler: {
                    values: [0, 100, 200, 300, 400, 500, 1000, 2000, 5000, 10000],
                    from_value: 0,
                    to_value: 10000
                },
                Venta: {
                    values: [0, 20000, 50000, 100000, 200000, 500000, 1000000, 2000000, 4000000, 8000000],
                    from_value: 0,
                    to_value: 8000000
                }
            };

            var currentPrecioMap = preciosMap.Alquiler;

            var inputOperacion = $('input[name="inmotek_busqueda[ope]"]');
            var precioMax = $hiddenPMax.val();
            var precioMin = $hiddenPMin.val();
            var metrosMin = $hiddenMMin.val();
            var metrosMax = $hiddenMMax.val();

            inputOperacion.change(function() {
                currentPrecioMap = preciosMap[$(this).val()];
                ionPrecio.update(currentPrecioMap);
                ionPrecio.reset();
            });

            inputOperacion.filter(':checked').trigger('change');

            if(
                (precioMax != null && precioMax != '') ||
                (precioMin != null && precioMin != '')
            ) {
                var tempPrecioMax = parseInt(precioMax, 10),
                    tempPrecioMin = parseInt(precioMin, 10),
                    indexPrecioMax = currentPrecioMap.values.indexOf(isNaN(tempPrecioMax) ? 0 : tempPrecioMax),
                    indexPrecioMin = currentPrecioMap.values.indexOf(isNaN(tempPrecioMin) ? 0 : tempPrecioMin);

                ionPrecio = $rangePrecio.data("ionRangeSlider");

                ionPrecio.update(
                    {
                        values: currentPrecioMap.values,
                        from: indexPrecioMin,
                        to: indexPrecioMax
                    }
                );
            }

            if(metrosMax != null && metrosMax != '') {
                ionMetros.update({to_value: metrosMax});
            }

            if(metrosMin != null && metrosMin != '') {
                ionMetros.update({from_value: metrosMin});
            }

            var formBusqueda = $('div.form-busqueda-wrapper'),
                paginacion = $('nav.paginador');

            paginacion.find('a').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                var form = formBusqueda.find('form');

                form.attr('action', $(this).attr('href'))
                form.submit();

                return false;
            });

            formBusqueda.find('button[type="submit"]').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                formBusqueda.find('form')
                    .attr('action', '/busqueda-inmuebles/')
                    .submit();

                return false;
            });

            $selectTipos.on('change', function() {
                var opt = $('<option/>');
                var tipoSeleccionado = $(this).find('option:selected').val();
                var subTiposSeleccionado = tipoSeleccionado != null && tipoSeleccionado != undefined
                    && tipoSeleccionado != '' ? subtipos[tipoSeleccionado] : [];

                $selectSubtipos
                    .html('')
                    .append(opt.clone().val('').html('Todos'));

                for(var i = 0; i < subTiposSeleccionado.length; i++) {
                    var nombre = subTiposSeleccionado[i];
                    console.log(nombre);
                    $selectSubtipos.append(
                        opt.clone().val(nombre).html(nombre)
                    );
                }

                $selectSubtipos.trigger('chosen:updated');
            });

            $selectLocalidad.on('change', function() {
                var opt = $('<option/>');
                var locSeleccionada = $(this).find('option:selected').val();
                var zonasLocSeleccionada = locSeleccionada != null && locSeleccionada != undefined
                && locSeleccionada != '' ? zonas[locSeleccionada] : [];

                $selectZonas
                    .html('')
                    .append(opt.clone().val('').html('Todas'));

                for(var i = 0; i < zonasLocSeleccionada.length; i++) {
                    var zona = zonasLocSeleccionada[i];
                    console.log(zona);
                    $selectZonas.append(
                        opt.clone().val(zona.id).html(zona.nombre)
                    );
                }

                $selectZonas.trigger('chosen:updated');
            });

        }

        function initInmuebleCards() {
            var $cards = $('.card-inmueble');

            $cards.each(function() {
                var $this = $(this),
                    $selectores = $this.find('.selector a'),
                    $tabs = $this.find('.precio'),
                    $capaReveal = $this.find('.foto div.sabana');

                $selectores.click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $tabs.removeClass('active');

                    $tabs.filter('.precio.' + $(this).attr('href').substr(1)).addClass('active');

                    return false;
                });

                $selectores.eq(0).click();

                $this.hover(function() {
                    $capaReveal.addClass('abierto');
                }, function() {
                    $capaReveal.removeClass('abierto');
                });

            });
        }

        function initFichaInmueble() {
            var $fichas = $('article.ficha-inmueble');

            $fichas.each(function() {
                var $this = $(this),
                    $selectoresOperacion = $this.find('header .operacion .selector a'),
                    $tabs = $this.find('header .operacion .precio');


                $selectoresOperacion.click(function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $tabs.removeClass('active');

                    $tabs.filter('.precio.' + $(this).attr('href').substr(1)).addClass('active');

                    return false;
                });

                $selectoresOperacion.eq(0).click();

                $owl = $this.find('.owl-carousel.fotos');

                $owl.owlCarousel({
                    loop: true,
                    autoplay: true,
                    lazyLoad: true,
                    center: true,
                    items: 1,
                    nav: false,
                    margin: 20,
                    dots: false
                });

                $this.find('.arrow').click(function() {
                    $owl.trigger($(this).attr('data-dir') + '.owl.carousel');
                });

            });
        }

        function scrollIntoView($el) {
            var offsetTop = $el.offset().top;
            var adjustment = Math.max(0,( $(window).height() - $el.outerHeight(true) ) / 2);
            var scrollTop = offsetTop - adjustment;

            $('html,body').scrollTop(scrollTop);

        }

        function initFlashMessages() {
            var $flash = $('div.flash');
            if($flash.length > 0) {
                scrollIntoView($flash);
            }
        }

        function initFormVendeAlquila() {
            initRadioFormWidget();
            initCheckboxFormWidget();
        }

        function initSimuladorHipoteca() {
            var $simuladores = $('div.simulador-hipoteca');

            $simuladores.each(function() {
                var $this = $(this),
                    $todosInputs = $this.find('input'),
                    $importe = $this.find('#importe-hipoteca'),
                    $interes = $this.find('#interes'),
                    $anios = $this.find('#anios'),
                    $entrada = $this.find('#entrada'),
                    $resultado = $this.find('div.resultado');

                $todosInputs.each(function() {
                    $(this).bind('input', function() {
                        var importeVal = $importe.val(),
                            interesVal = $interes.val(),
                            aniosVal = $anios.val(),
                            entradaVal = $entrada.val();

                        if(isNaN(importeVal) || isNaN(interesVal) || isNaN(aniosVal) || isNaN(entradaVal)) {
                            $resultado.find('span').val('-');
                            return;
                        }

                        var importe = parseInt(importeVal, 10),
                            interes = parseFloat(interesVal),
                            anios = parseInt(aniosVal, 10),
                            entrada = parseInt(entradaVal, 10),
                            aFinanciar = importe - entrada,
                            importeInteres = (aFinanciar * interes) / 100,
                            resultado = '-';

                        resultado = (aFinanciar + importeInteres) / anios / 12;

                        if(isNaN(importeVal) || isNaN(interesVal) || isNaN(aniosVal) || isNaN(entradaVal) || isNaN(resultado)) {
                            $resultado.find('span').val('-');
                            return;
                        }

                        $resultado.find('span').html(resultado.toFixed(2).toLocaleString());
                    });
                });

                $importe.trigger('input');

            });

        }

        function getFavs() {
            return Cookies.getJSON('favs') || [];
        }

        function setFav(id) {
            var favs = getFavs();
            var intId = parseInt(id || 0, 10);

            if(isNaN(intId) || intId == 0) {
                return;
            }

            if(favs.indexOf(intId) != -1) {
                return;
            }

            //console.log('Set fav: ' + intId);

            favs.push(intId);

            Cookies.set('favs', favs, {expires: 365});
        }

        function removeFav(id) {
            var favs = getFavs();
            var intId = parseInt(id || 0, 10);

            if(isNaN(intId) || intId == 0) {
                return;
            }

            var index = favs.indexOf(intId);

            if(index == -1) {
                return;
            }

            //console.log('Set fav: ' + intId);

            favs.splice(index, 1);

            Cookies.set('favs', favs, {expires: 365});
        }

        function isFav(favs, id) {
            var intId = parseInt(id || 0, 10);

            if(isNaN(intId) || intId == 0) {
                return false;
            }

            return favs.indexOf(intId) != -1;
        }

        function updateCorazones() {
            var favIds = getFavs();
            var corazones = $('div.agregar-favorito');

            if(favIds.length == 0) {
                return;
            }

            corazones.each(function() {
                var $this = $(this);

                if(isFav(favIds, $this.attr('data-id'))) {
                    $this.addClass('active');
                }else {
                    $this.removeClass('active');
                }
            });
        }

        function updateFavHeader() {
            var favIds = getFavs();

            $('header.main').find('div.favoritos span').html(favIds.length);
        }

        function updateFavButtons() {
            var favButtons = $('button.agregar-favorito');
            var favIds = getFavs();

            if(favIds.length == 0) {
                return;
            }

            favButtons.each(function() {
                var $this = $(this);

                if(isFav(favIds, $this.attr('data-id'))) {
                    $this.addClass('faved');
                }else {
                    $this.removeClass('faved');
                }
            });

        }

        function initFavoritos() {
            var favs = $('div.agregar-favorito');

            favs.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                //console.log('heart click fired');

                var $this = $(this),
                    id = $this.attr("data-id");

                if($this.hasClass('active')) {
                    removeFav(id);
                }else {
                    setFav(id);
                }


                updateCorazones();
                updateFavHeader();
                updateFavButtons();

                return false;
            });

            var favButtons = $('button.agregar-favorito');

            favButtons.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    id = $this.attr("data-id");

                if($this.hasClass('faved')) {
                    removeFav(id);
                }else {
                    setFav(id);
                }

                updateCorazones();
                updateFavHeader();
                updateFavButtons();

                return false;
            });

            updateCorazones();
            updateFavHeader();
            updateFavButtons();
        }

        function initTraductor() {
            $idiomas.click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                window.location.hash = 'googtrans(' + $(this).attr('class') + ')';
                window.location.reload();

                return false;
            });
        }

        function googleTranslateElementInit() {
            new google.translate.TranslateElement({pageLanguage: 'es', includedLanguages: 'de,en,fr', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, autoDisplay: false}, 'google_translate_element');
        }

        function registrarVisitaInmueble(path, db, id, url, referer) {
            window.setTimeout(function() {
                jQuery.ajax({
                    'url': path,
                    'method': 'POST',
                    'data': {'id': id, 'db': db, 'url': url, 'referer': referer}
                }).done(function(data) {
                    //console.log(data);
                }).fail(function(jqXHR, textStatus, errorThrown) {
                    console.error('Ocurrió un error registrado la visita al inmueble', errorThrown);
                });

            }, 6000);
        }

        function initAvisoCookies() {

            var avisoAceptado = Cookies.get('aviso_cookies_aceptado') || 0;
            var $aviso = $('div#aviso-cookies');

            $aviso.find('button').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                Cookies.set('aviso_cookies_aceptado', 1, {expires: 365});
                $aviso.removeClass('mostrar');

                return false;
            });

            if(avisoAceptado != 1) {
                $aviso.addClass('mostrar');
            }
        }

        function initSubscribeNewsletter() {
            var $formSuscribir = $('form#suscribir-newsletter');

            $formSuscribir.on('submit', function(e) {
                console.log('on newsletter subscribe');
                e.stopPropagation();
                e.preventDefault();

                var $inputEmail = $formSuscribir.find('#suscribir-email'),
                    $boton = $formSuscribir.find('button'),
                    $flash = $formSuscribir.find('.suscribir-flash');

                var textBoton = $boton.html();
                $boton
                    .html('Por favor, espera...')
                    .prop('disabled', true);

                $flash.removeClass('mostrar');

                $.ajax({
                    'url': $formSuscribir.attr('action'),
                    'method': 'POST',
                    'data': {'email': $inputEmail.val() }
                }).done(function(response) {
                    $flash.html(response['reason']);

                    if(response['status'] == 'ok') {
                        $inputEmail.val('');
                    }

                }).fail(function() {
                    $flash.html('Ocurrió un error. Por favor inténtalo más tarde');
                }).always(function() {
                    $boton
                        .html(textBoton)
                        .prop('disabled', false);
                    $flash.addClass('mostrar');
                });

                return false;
            });
        }

        function centerIn($target, $container) {
            var containerWidth = $container.outerWidth(),
                containerHeight = $container.outerHeight(),
                targetWidth = $target.outerWidth(),
                targetHeight = $target.outerHeight();

            var left = (containerWidth / 2) - (targetWidth / 2),
                top = (containerHeight / 2) - (targetHeight / 2);

            $target.css({
                'left': left + 'px',
                'top': top + 'px'
            });
        }

        function initAvisoLegalFormularios() {

            var $cortina = $('.cortina'),
                $aviso = $('.aceptacion-datos'),
                $aceptar = $aviso.find('.aceptar'),
                $rechazar = $aviso.find('.rechazar');

            function showAvisoLegal($target) {
                $cortina.addClass('abrir');
                centerIn($aviso, $(window));
                $aviso.data('target', $target);
                $aviso.show();
            }

            function hideAvisoLegal() {
                $aviso.data('target', null);
                $aviso.hide();
                $cortina.removeClass('abrir');
            }

            function agreeAvisoLegal() {
                var $target = $aviso.data('target');
                $target.attr('data-agreed', '1');
                $target.trigger('submit');

                hideAvisoLegal();
            }

            $aceptar.on('click', agreeAvisoLegal);
            $rechazar.on('click', hideAvisoLegal);

            var $targets = $('.trigger-aviso-legal');

            $targets.each(function() {
                var $target = $(this);

                $target.on('submit', function(event) {

                    if($target.attr('data-agreed') === '1') {
                        return true;
                    }

                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    showAvisoLegal($target);

                    return false;
                });

                $target.attr('data-processed', 'true');

            });
        }

        function init360Player() {
            var iframe = $('<iframe id="ytplayer" type="text/html" frameborder="0" modestbranding="1" allowfullscreen="allowfullscreen" controls="2"/>'),
                modal = $('#modal-360'),
                modalContent = modal.find('.modal__content'),
                videoId = modal.attr('data-video')
            ;

            MicroModal.init({
                onShow: function() {
                    if(modalContent.find('iframe').length > 0) {
                        return;
                    }

                    iframe.attr('src', 'https://www.youtube.com/embed/' + videoId);
                    modalContent.find('.player').append(iframe);
                },
                disableScroll: true
            });


        }

        exports.googleTranslateElementInit = googleTranslateElementInit;
        exports.initInmuebleCards = initInmuebleCards;
        exports.initSliderInmuebles = initSliderInmuebles;
        exports.initSliderBusqueda = initSliderBusqueda;
        exports.initFormBusqueda = initFormBusqueda;
        exports.initFichaInmueble = initFichaInmueble;
        exports.initInmuebleCards = initInmuebleCards;
        exports.initFormVendeAlquila = initFormVendeAlquila;
        exports.initFlashMessages = initFlashMessages;
        exports.initSimuladorHipoteca = initSimuladorHipoteca;
        exports.initFavoritos = initFavoritos;
        exports.initTraductor = initTraductor;
        exports.registrarVisitaInmueble = registrarVisitaInmueble;
        exports.initAvisoCookies = initAvisoCookies;
        exports.initSubscribeNewsletter = initSubscribeNewsletter;
        exports.init360Player = init360Player;

        var $chosen = $('select.chosen');

        $chosen.chosen({
            width: '100%'
        });



    });

})(window, jQuery);

